const throwError = (message: string) => {
  throw new Error(message)
}

//Landing page url
const LANDING_PAGE_URL =
  process.env.REACT_APP_LANDING_URL || 'https://dev.cashcollector.eu'

const config = {
  accessTokenKey: 'cashCollectorAccessToken',
  idTokenKey: 'cashCollectorIdToken',
  refreshTokenKey: 'cashCollectorRefreshToken',
  languageKey: 'cashCollectorLanguage',

  selectedAccountantCompanyKey: 'selectedAccountantCompany',
  errorNamespace: 'errors',
  apiUrl:
    process.env.REACT_APP_API_URL ||
    throwError('Missing API_URL env variable.'),
  ENTER_KEY: 'Enter',
  TAB_KEY: 'Tab',
  PLUS_KEY: '+',
  MINUS_KEY: '-',
  SEARCH_MIN_CHARACTERS: 3,
  DEFAULT_DEBOUNCE_TIMEOUT: 500,

  ALLOWED_FILE_EXTENSIONS: ['xls', 'xlsx'],
  ALLOWED_POWER_OF_ATTORNEY_EXTENSIONS: ['pdf', 'png', 'jpeg'],

  AWS_POOL_ID:
    process.env.REACT_APP_AWS_POOL_ID ||
    throwError('Missing AWS_POOL_ID env variable.'),
  AWS_CLIENT_ID:
    process.env.REACT_APP_AWS_CLIENT_ID ||
    throwError('Missing AWS_CLIENT_ID env variable.'),

  LANDING_PAGE_REGULATIONS_URL_PL: `${LANDING_PAGE_URL}/regulamin-aplikacji/`,
  LANDING_PAGE_FAQ_URL_PL: `${LANDING_PAGE_URL}/faq/`,
  LANDING_PAGE_SUPPORT_URL_PL: `${LANDING_PAGE_URL}/pomoc/`,
  LANDING_PAGE_PRIVACY_URL_PL: `${LANDING_PAGE_URL}/polityka-prywatnosci/`,

  LANDING_PAGE_REGULATIONS_URL_EN: `${LANDING_PAGE_URL}/en/application-terms-and-conditions/`,
  LANDING_PAGE_FAQ_URL_EN: `${LANDING_PAGE_URL}/en/faq/`,
  LANDING_PAGE_SUPPORT_UR_EN: `${LANDING_PAGE_URL}/en/help/`,
  LANDING_PAGE_PRIVACY_URL_EN: `${LANDING_PAGE_URL}/en/privacy-policy/`,
  APPLE_STORE_PATH:
    process.env.REACT_APP_APPLE_STORE_APP_URL ||
    'https://apps.apple.com/us/app/cash-collector/id1642488921',
  ANDROID_STORE_PATH: process.env.REACT_APP_ANDROID_APP_URL || '',
}

export default config
